import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import grey from "@material-ui/core/colors/grey";

const useStyles = makeStyles((theme) => ({
  root: (props) => ({
    background: props.primaryColor ? theme.palette.primary.main : "white",
    color: props.primaryColor ? "white" : "#999",
    display: "flex",
    borderBottom: `solid 1px ${grey[300]}`,
  }),
}));

function ToolbarStyle(props) {
  const classes = useStyles(props);
  const { className, ...other } = props;
  return <div className={`${classes.root} ${className}`} {...other} />;
}

export default ToolbarStyle;



// WEBPACK FOOTER //
// ./src/pages/MagnetReport/components/ToolbarStyle/index.jsx